module.exports = __webpack_public_path__ + "img/help-title-zh_2c8414bdb.png";